export default "/_next/static/images/60f33c09f15a2635c86168cdc52278b0.png";